import { render, staticRenderFns } from "./DeviceAlert.vue?vue&type=template&id=5f4a5ef0&scoped=true"
import script from "./DeviceAlert.vue?vue&type=script&lang=js"
export * from "./DeviceAlert.vue?vue&type=script&lang=js"
import style0 from "./DeviceAlert.vue?vue&type=style&index=0&id=5f4a5ef0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a5ef0",
  null
  
)

export default component.exports